export enum EPaymentCheckType {
  Balance = 'Balance',
  Package = 'Package',
}

export enum EPaymentStatus {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Canceled = 'canceled',
}
